import { named, withDependencies, optional } from '@wix/thunderbolt-ioc'
import type { ServiceProvider } from '@wix/thunderbolt-symbols'
import { PageFeatureConfigSymbol } from '@wix/thunderbolt-symbols'
import type { ServiceFactoryOpts } from '@wix/services-manager/types'
import type { IContextBindingServiceConfig, IContextBindingServiceDefinition } from './contextBindingService'
import { ContextBindingServiceDefinition } from './contextBindingService'
import { createContextBindingService } from './contextBindingServiceImpl'
import { BuilderContextBindingStoreSymbol } from '../symbols'
import { name } from '../symbols'
import type { BuilderContextProvidersPageConfig, ICompChangeStore } from '../types'

export const ContextBindingService = withDependencies(
	[named(PageFeatureConfigSymbol, name), optional(BuilderContextBindingStoreSymbol)],
	(
		pageFeatureConfig: BuilderContextProvidersPageConfig,
		store?: ICompChangeStore
	): ServiceProvider<
		IContextBindingServiceDefinition,
		(ops: ServiceFactoryOpts<IContextBindingServiceConfig>) => any
	> => {
		return {
			definition: ContextBindingServiceDefinition,
			impl: ({ config }) => createContextBindingService(config, store),
			config: {
				compIdToBindingMap: pageFeatureConfig.compIdToBindingMap,
			},
		}
	}
)

export const NoopContextBindingService = withDependencies(
	[],
	(): ServiceProvider<
		IContextBindingServiceDefinition,
		(ops: ServiceFactoryOpts<IContextBindingServiceConfig>) => any
	> => {
		// This service is used in every component, some components do not belong to a page (such as main_MF) and should be ignored,
		// since the service api forbid calling useService for an undefined service definition we must provide a noop implementation
		// for those skipped components (we are not allowed to use if statements inside the React component wrapper
		return {
			definition: ContextBindingServiceDefinition,
			impl: ({ config }) => createContextBindingService(config),
			config: {
				compIdToBindingMap: {},
			},
		}
	}
)
